import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';
import OptionsStep from "./OptionsStep";


class SentSMS extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            trigger: false,
            showOptions: false,
            timerId:null,
        };

        this.triggetNext = this.triggetNext.bind(this);
    }

    componentDidMount() {
        const self = this;
        const {steps, store} = this.props;
        const bodyFormData = new FormData();

        if (!store.patient.id) {
            bodyFormData.append('phone', steps.userPhone.value);
        } else {
            bodyFormData.append('patient_id', store.patient.id);
        }

        bodyFormData.append('length', 4);
        API.post(
            '/smsCode',
            bodyFormData,
            {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {
            const result = res.data;
            if (result.status == "success") {
                self.setState({
                    loading: false,
                });
                self.triggetNext(true, 'smsCode');
            }
            this.setState({
                timerId: setTimeout(() => {
                    this.props.triggerNextStep({value: true, trigger: 'afterMinuteSmsSent',disable:true})
                }, 90000)
            })
        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
            self.triggetNext(true, 'afterMinuteSmsSent');

        });
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }

    componentWillUnmount() {
        const {timerId} = this.state;
        if (timerId) {
            clearTimeout(timerId);
        }

    }

    shouldComponentUpdate(){
        const {timerId} = this.state;
        const {steps} = this.props;
        if(timerId){
            if(typeof steps.checkSmsCode == "object"){
                clearTimeout(timerId);
                this.setState({
                    timerId:null
                })
            }
        }
        return true;
    }

    render() {
        const {loading, showOptions} = this.state;
        const { step, bubbleOptionStyle, previousStep, allSteps,store} = this.props;
        const {texts} = store.settings;
        return (
            <div>
                {loading ? (<div>
                        {texts.iAmSendingSms} <Loading/>
                    </div>
                ) : (
                    <div>
                        <div>{allSteps.we_sent_you_sms_code.message}</div>

                        {showOptions ? (
                        <OptionsStep
                            // key={index}
                            options={allSteps.afterMinuteSmsSent.options}
                            step={step}
                            speak={false}
                            previousValue={previousStep.value}
                            triggerNextStep={this.triggetNext}
                            bubbleOptionStyle={bubbleOptionStyle}
                        />
                        ):('')}
                    </div>
                )}
            </div>
        );
    }


}

SentSMS.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

SentSMS.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default SentSMS;
